//@ts-nocheck
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import { Box, Button, Center, Image } from "native-base";
import { FeedsLoader, Loader } from "../../components/loaders";
import CreatePostpopup from "Screens/Home/CreatePostpopup";
import Offline from "react-offline";
import msg from "../../assets/images/create-message.png";
import { Loc } from "../../App/Loc";
import * as AV from "../../AVCore/AVCore";
import Card from "../../components/posts/Card";
import useFeeds from "../../Hooks/useFeeds";
import InfiniteScroll from "react-infinite-scroller";
import _ from "lodash";
import { store } from "../../Redux/store";
import {
  setFeedsScrollUpdate,
  setFeedsUpdate,
  setFeeds,
  setFetchProcess,
} from "../../Redux/Actions/feedsAction";
import useAlerts from "../../Hooks/useAlerts";
import { setNewPosts, setRealUpdate } from "../../Redux/Actions/userActions";

const currentUrl = window.location.href;

// Helper Hook to handle post permissions logic
const usePostPermissions = (userInfo, currentUser) => {
  const isMember = userInfo?.members?.some((x) => x?.id === currentUser?.id);
  const isPlayerOfEntity = userInfo?.players?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isAllowMemberPost =
    isMember && userInfo?.preferences?.memberPost !== "N";
  const isAllowPlayerPost =
    isPlayerOfEntity && userInfo?.preferences?.playerPost !== "N";
  const visibilityPermission = isMember
    ? userInfo?.preferences?.memberPost
    : isPlayerOfEntity
      ? userInfo?.preferences?.playerPost
      : "F";
  return {
    isAllowMemberPost,
    isAllowPlayerPost,
    visibilityPermission,
  };
};

const AVFeeds = (props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.user[0]);
  const userFeeds = useSelector((state) => state.feeds.feeds[0]) ?? [];
  const { userInfo } = props;
  const [isLoadingNewPosts, setIsLoadingNewPosts] = useState(false);

  const isMemberOfEntity = userInfo?.members?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isPlayerOfEntity = userInfo?.players?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isstaffOfEntity = userInfo?.staff?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isParticipantOfEntity = userInfo?.participants?.some(
    (x) => x?.id === currentUser?.id,
  );
  //const postPopupExpanded = useSelector(
  //  (state : RootStateOrAny) => state.user.postPopupExpanded,
  //);

  const isCurrentUser = userInfo?.id === currentUser?.id;
  const isOwner = isstaffOfEntity || isCurrentUser || isParticipantOfEntity;
  const isOneOfEntity =
    isMemberOfEntity || isPlayerOfEntity || isstaffOfEntity || isCurrentUser;

  let IsVisible =
    userInfo?.id == "78b5b063-fd3e-4925-92bd-2a1888c6a46a" ||
    userInfo?.id == "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
    userInfo?.id == "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
    userInfo?.id == "b495d4e0-bf52-4690-8dc0-677db954aa72"
      ? "P"
      : isOwner
        ? "B"
        : !isOneOfEntity && props?.page !== "Home"
          ? "N"
          : props?.page == "Home"
            ? "B"
            : props?.Postdata?.preferences?.memberPost
              ? props?.Postdata?.preferences?.memberPost
              : userInfo?.preferences?.memberPost;

  IsVisible = userInfo?.type == "Channel" ? "B" : IsVisible;

  const { isAllowMemberPost, isAllowPlayerPost, visibilityPermission } =
    usePostPermissions(userInfo, currentUser);

  const [isShowCreatePost, setIsShowCreatePost] = useState(
    props?.isShowCreatePost ?? true,
  );
  const [processedAllPostsInRedux, setProcessedAllPostsInRedux] =
    useState(false);

  const [isFetchingNextPage, setFetchingNextPage] = useState(false);
  const [feedChunks, setFeedChunks] = useState([]);
  const [feedsProcessed, setFeedsProcessed] = useState(0);
  const [hasMorePosts, setHasMorePosts] = useState(true); // Track if there are more posts

  let RealyUpdatedPost = useSelector(
    (state: RootStateOrAny) => state?.user?.realUpdate,
  );
  const feedsScrollUpdate = useSelector(
    (state: RootStateOrAny) => state.feeds.feedsScrollUpdate,
  );
  const NewlyUpdatedPost = useSelector(
    (state: RootStateOrAny) => state?.user?.newPost,
  );

  const { handlerefetch } = useAlerts();
  const dimensions = useWindowDimension();
  const isMobile = dimensions?.width <= 500 || false;
  const fetchProcess = useSelector((state: any) => state.feeds.fetchProcess);
  const [showModal, setShowModal] = useState(false);
  const [isCacheLoading, setIsCacheLoading] = useState(false);

  const {
    fetchPosts,
    fetchNewPosts,
    processedAllPosts,
    list_to_tree,
    setProcessedAllPosts,
    fetchReplyPosts,
  } = useFeeds(props);

  // Memoized Loader Component
  const MemoizedLoader = React.memo(() => (
    <Box m={5}>
      <Loader />
    </Box>
  ));

  // Memoized Card Component
  const MemoizedCard = React.memo(Card);

  // Function to load more posts (triggering fetchNextPage if needed)
  const loadPosts = async () => {
    if (isFetchingNextPage || !hasMorePosts) return;

    const currentFeedsInRedux = store.getState().feeds.feeds[0] ?? [];
    const fetchProcess = store.getState().feeds.fetchProcess[0];

    if (!fetchProcess) {
      // todo: check if we need to fetch posts from server

      // Filter feeds where IsVisible is false
      let filteredFeeds = [];
      if (props?.page === "Profile" && props?.id) {
        filteredFeeds = currentFeedsInRedux
          .filter((feed) => !feed.IsVisible && feed.owner?.id === props?.id)
          .slice(0, 20);
      } else {
        filteredFeeds = currentFeedsInRedux
          .filter((feed) => !feed.IsVisible)
          .slice(0, 20);
      }

      if (filteredFeeds.length > 0) {
        if (filteredFeeds.length < 20) {
          // Call fetchPosts in useFeeds without await
          fetchPosts(); // This will run in the background
        }

        // Set the first 20 feeds as IsVisible = true
        filteredFeeds.forEach((feed) => {
          feed.IsVisible = true; // Update visibility
        });

        // Update feedChunks with the new filtered feeds
        let FinalAllPost = list_to_tree(filteredFeeds);

        if (FinalAllPost.length > 0) {
          setFeedChunks((prevChunks) => {
            const updatedChunks = [...prevChunks, ...FinalAllPost];
            return _.uniqBy(updatedChunks, "id"); // Remove duplicates based on 'id'
          });
        }
        return; // Exit the function after updating visibility
      } else {
        // If no filtered feeds, call fetchPosts in useFeeds
        const newPosts = await fetchPosts();
        //if (!currentUrl.includes("huddles")) {
        //    setHasMorePosts(false);
        //}
        if (newPosts?.length > 0) {
          // Update feedChunks with the new posts
          setFeedChunks((prevChunks) => {
            const updatedChunks = [...prevChunks, ...newPosts];
            return _.uniqBy(updatedChunks, "id"); // Remove duplicates based on 'id'
          });
        } else {
          if (props?.page === "Profile" && newPosts?.length == 0) {
            setHasMorePosts(false);
          }
        }
      }
    } else {
      setHasMorePosts(false);
    }
  };

  // Function to load new posts
  const loadNewPosts = async () => {
    setIsLoadingNewPosts(true); // Show the loader

    // Fetch new posts
    const newPosts = await fetchNewPosts();

    if (newPosts?.length > 0) {
      setFeedChunks((prevChunks) => {
        const updatedChunks = [...prevChunks]; // Clone the existing chunks

        newPosts.forEach((newPost) => {
          // Check if parentPost exists in prevChunks
          const parentIndex = newPost.parentPost
            ? updatedChunks.findIndex((post) => post.id === newPost.parentPost)
            : -1;

          if (parentIndex !== -1) {
            if (!updatedChunks[parentIndex].children) {
              updatedChunks[parentIndex].children = []; // Initialize children array if not present
            }

            // Update existing parent post with new data
            if (updatedChunks[parentIndex]?.gallery?.length == 0) {
              updatedChunks[parentIndex] = {
                ...updatedChunks[parentIndex],
                children: [
                  ...updatedChunks[parentIndex].children, // Preserve existing comments
                  newPost, // Add the new comment
                ].sort(
                  (a, b) =>
                    new Date(b.createDate).getTime() -
                    new Date(a.createDate).getTime(),
                ), // Sort by creation date (newest first)
              };
            }
          } else {
            // Add new post if no parent found
            updatedChunks.push(newPost);
          }
        });

        return _.uniqBy(updatedChunks, "id"); // Ensure uniqueness
      });

      let ExistingFeed = [...userFeeds];

      newPosts.forEach((newPost) => {
        // Check if parentPost exists in userFeeds
        const parentIndex = newPost.parentPost
          ? ExistingFeed.findIndex((post) => post.id === newPost.parentPost)
          : -1;

        if (parentIndex !== -1) {
          if (!ExistingFeed[parentIndex].children) {
            ExistingFeed[parentIndex].children = []; // Initialize children array if not present
          }
          if (ExistingFeed[parentIndex]?.gallery?.length == 0) {
            // Update existing parent post
            ExistingFeed[parentIndex] = {
              ...ExistingFeed[parentIndex],
              children: [
                ...ExistingFeed[parentIndex].children, // Preserve existing comments
                newPost, // Add the new comment
              ].sort(
                (a, b) =>
                  new Date(b.createDate).getTime() -
                  new Date(a.createDate).getTime(),
              ), // Sort by creation date (newest first)
            };
          }
        } else {
          // Add new post if no parent found
          ExistingFeed.push(newPost);
        }
      });

      ExistingFeed = _.uniqBy(ExistingFeed, "id");
      ExistingFeed = ExistingFeed.sort((a, b) => {
        const dateA = new Date(a?.createDate).getTime();
        const dateB = new Date(b?.createDate).getTime();
        return dateB - dateA; // Sort posts by creation date in descending order
      });

      dispatch(setFeeds(ExistingFeed));
    }

    initialLoad(); // Reset the feeds
    setIsLoadingNewPosts(false); // Hide the loader
  };

  const LoadCacheNewPost = async () => {
    if (isCacheLoading) {
      setTimeout(() => {
        setIsCacheLoading(false);
      }, 0);
      return;
    }

    setTimeout(() => {
      setIsCacheLoading(true);
    }, 0);
    let NewlyPost = [];
    let postsToFetch = [];
    let FinalAllPost;
    let NewlyGetPost = [];

    if (NewlyUpdatedPost?.length > 0) {
      NewlyUpdatedPost.forEach((post) => {
        let ids = post?.ids || [];
        if (ids.length > 0) {
          postsToFetch.push({
            feed: post?.feed,
            ids: post?.ids,
          });
        }
        NewlyPost.push(post?.posts);
      });

      if (postsToFetch.length > 0) {
        NewlyGetPost = await AV.Feed.getAllPosts(postsToFetch);

        // Fetch Reply Posts
        if (NewlyGetPost && Array.isArray(NewlyGetPost)) {
          const updatedPostList = await fetchReplyPosts(
            NewlyGetPost,
            postsToFetch,
          );
          NewlyGetPost = updatedPostList;
        }
      }

      FinalAllPost =
        NewlyGetPost.length > 0
          ? [...NewlyGetPost, ...NewlyPost]
          : [...NewlyPost];

      FinalAllPost = list_to_tree(FinalAllPost);

      if (FinalAllPost.length > 0) {
        FinalAllPost.sort(
          (a, b) => new Date(b?.createDate) - new Date(a?.createDate),
        );

        setFeedChunks((prevChunks) => {
          const updatedChunks = [...FinalAllPost, ...prevChunks];
          return _.uniqBy(updatedChunks, "id"); // Remove duplicates
        });

        let ExistingFeed = [...userFeeds, ...FinalAllPost];
        ExistingFeed = _.uniqBy(ExistingFeed, "id");
        ExistingFeed.sort(
          (a, b) => new Date(b?.createDate) - new Date(a?.createDate),
        );

        dispatch(setNewPosts([]));
        dispatch(setFeeds(ExistingFeed));
        setTimeout(() => {
          setIsCacheLoading(false);
        }, 0);

        return;
      }
    }

    // If there are no new posts, delay resetting isCacheLoading
    setTimeout(() => {
      setIsCacheLoading(false);
    }, 1000);
    loadNewPosts();
  };

  useEffect(() => {
    let isMounted = true;

    if (feedsScrollUpdate || props?.isHuddlePostTab) {
      if (isMounted) {
        scrollToTop();
        dispatch(setFeedsScrollUpdate(false));
      }
    }

    return () => {
      isMounted = false;
    };
  }, [feedsScrollUpdate]);

  useEffect(() => {
    let isMounted = true;

    const FetchData = async () => {
      if (RealyUpdatedPost?.length) {
        let updatedChunks = [...feedChunks];
        let updatedFeeds = [...userFeeds];
        let isChunksChanged = false;
        let isFeedsChanged = false;

        RealyUpdatedPost.forEach((updatedPost) => {
          const postId = updatedPost?.posts?.id;

          if (updatedPost?.alertType === "UpdatePost") {
            // Update feedChunks
            const chunkIndex = updatedChunks.findIndex((x) => x?.id === postId);
            if (chunkIndex !== -1) {
              updatedChunks[chunkIndex] = {
                ...updatedPost.posts,
                children:
                  updatedPost?.posts?.children ??
                  updatedChunks[chunkIndex]?.children,
                gallery:
                  updatedPost?.posts?.gallery ??
                  updatedChunks[chunkIndex]?.gallery,
                galleryPost:
                  updatedPost?.posts?.galleryPost ??
                  updatedChunks[chunkIndex]?.galleryPost,
              };

              isChunksChanged = true;
            }

            // Update userFeeds
            const feedIndex = updatedFeeds.findIndex((x) => x?.id === postId);
            if (feedIndex !== -1) {
              updatedFeeds[feedIndex] = {
                ...updatedPost.posts,
                children:
                  updatedPost?.posts?.children ??
                  updatedFeeds[feedIndex]?.children,
                gallery:
                  updatedPost?.posts?.gallery ??
                  updatedFeeds[feedIndex]?.gallery,
                galleryPost:
                  updatedPost?.posts?.galleryPost ??
                  updatedFeeds[feedIndex]?.galleryPost,
              };
              isFeedsChanged = true;
            }
          } else if (updatedPost?.alertType === "DeletePost") {
            updatedChunks = updatedChunks.filter((x) => x?.id !== postId);
            updatedFeeds = updatedFeeds.filter((x) => x?.id !== postId);
            isChunksChanged = true;
            isFeedsChanged = true;
          } else if (updatedPost?.alertType === "PostReview") {
            if (isMounted) ReviewPost();
          }
        });

        if (isMounted && isChunksChanged) setFeedChunks(updatedChunks);
        if (isMounted && isFeedsChanged) dispatch(setFeeds(updatedFeeds));

        dispatch(setRealUpdate([]));
      }
    };

    FetchData();

    return () => {
      isMounted = false;
    };
  }, [RealyUpdatedPost?.length, RealyUpdatedPost, RealyUpdatedPost?.alertType]);

  const ReviewPost = async () => {
    let PostReview = feedChunks?.filter(
      (x) => x?.id == usernewalert?.target?.id,
    );

    if (PostReview?.length > 0 && PostReview[0]?.modStatus !== "NR") {
      let post = PostReview[0];
      post.modStatus = "NR";
      feedChunks[feedChunks.indexOf(PostReview[0])] = post;
      setFeedChunks(feedChunks);
    } else {
      let postreply = await AV.Post.get(usernewalert?.target);
      let parentPost = await AV.Post.get({
        id: postreply?.parentPost,
        pk: postreply?.pk,
        region: postreply?.region,
        type: postreply?.type,
      });

      let ppost1: any = feedChunks?.filter((x) => x.id === parentPost?.id);
      if (ppost1?.length > 0) {
        let finalPost = ppost1[0]?.children?.filter(
          (x) => x?.id === usernewalert?.target?.id,
        );
        finalPost[0].modStatus = "NR";
        let index = ppost1[0]?.children?.findIndex(
          (x) => x?.id === finalPost[0]?.id,
        );

        if (index !== -1) ppost1[0].children[index] = finalPost[0];
        feedChunks[feedChunks.indexOf(ppost1[0])] = ppost1[0];
        setFeedChunks(feedChunks);
      }
    }
  };

  // scrollToTop will trigger the loadNewPosts function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // handlerefetch();
    // loadNewPosts();
    LoadCacheNewPost();
  };

  const initialLoad = () => {
    const currentFeedsInRedux = store.getState().feeds.feeds[0] ?? [];
    // Set all feeds as IsVisible = false
    const updatedFeeds = currentFeedsInRedux.map((feed) => ({
      ...feed,
      IsVisible: false, // Set IsVisible to false
    }));
    // Order feeds by createDate
    const sortedFeeds = updatedFeeds.sort(
      (a, b) => new Date(b.createDate) - new Date(a.createDate),
    );
    // Dispatch the updated feeds to Redux
    dispatch(setFeeds(sortedFeeds));

    store.dispatch(setFetchProcess(false));
    setProcessedAllPosts(false);

    // Reset feed chunks and processed state whenever props change
    setFeedChunks([]);
    setFeedsProcessed(0);
    setProcessedAllPostsInRedux(false);
    setHasMorePosts(true); // Reset hasMorePosts

    // finally call loadPosts
    loadPosts();
  };

  // when the user info change i.e teams to season load the feed
  useEffect(() => {
    initialLoad();
  }, [props?.page]);

  // Filter posts if the page is Profile
  const filteredPosts = useMemo(() => {
    if (props?.page === "Profile" && props?.id) {
      if (props?.userInfo?.series) {
        return feedChunks.filter(
          (post) => post?.owner?.id == props?.userInfo?.series,
        );
      }
    }
    return feedChunks;
  }, [props?.page, props?.id, feedChunks]);


  useEffect(() => {
    if (showModal/* || postPopupExpanded*/) {
      document.body.style.overflow = "hidden";   // disable scroll
    } else {
      document.body.style.overflow = "auto";     // enable scroll back
    }
  }, [showModal/*, postPopupExpanded*/]);

  return (
    <Box>
      {!showModal && IsVisible !== "N" && isShowCreatePost && (
        <Offline>
          {({ isOffline }) =>
            !isOffline && (
              <Button
                bgColor="AVColor.primary"
                borderRadius="full"
                padding={3}
                height="45px"
                width="45px"
                onPress={() => setShowModal(true)}
                zIndex={1}
                position="fixed"
                bottom={isMobile ? "110px" : "10px"}
                marginLeft={
                  props?.isHuddlePostTab
                    ? props?.offW
                      ? props.offW - 60
                      : 570
                    : props?.offW
                      ? props?.offW - 60
                      : 100
                }
              >
                <Image source={msg} alt="Create Post" size="25px" />
              </Button>
            )
          }
        </Offline>
      )}

      {/* Skeleton Loader for new posts */}
      {isLoadingNewPosts && filteredPosts.length == 0 && (
        <Box m={5}>
          {Array(5)
            .fill(null)
            .map((_, i) => (
              <FeedsLoader key={i} />
            ))}
        </Box>
      )}

      {isCacheLoading && (
        <Box m={5}>
          {Array(5)
            .fill(null)
            .map((_, i) => (
              <FeedsLoader key={i} />
            ))}
        </Box>
      )}

      <div className="feed-container">
        {filteredPosts.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            loadMore={loadPosts}
            hasMore={hasMorePosts && !isFetchingNextPage} // Update hasMore logic
            loader={
              <Center key={0}>
                <MemoizedLoader />
              </Center>
            }
            useWindow={true}
            threshold={200}
          >
            <div className="posts-list">
              {filteredPosts.length > 0 &&
                filteredPosts.map((post, i) => (
                  <div key={`${post?.id}+${i}`}>
                    <MemoizedCard
                      key={`${post.id}+${i}`}
                      iscommentAccess={props?.previewdata?.iscommentAccess}
                      data={post}
                      setFeedChunks={setFeedChunks}
                      feedChunks={feedChunks}
                      previewdata={userInfo}
                      userInfo={
                        props?.page === "Home"
                          ? currentUser
                          : props?.previewdata?.userInfo
                      }
                      isHuddlePostTab={props?.isHuddlePostTab ?? false}
                    />
                  </div>
                ))}
            </div>
          </InfiniteScroll>
        )}

        {/* Loader for fetching next page */}
        {isFetchingNextPage && filteredPosts.length > 0 && (
          <Center>
            <Box m={5}>
              <Loader />
            </Box>
          </Center>
        )}

        {filteredPosts.length == 0 && hasMorePosts && <FeedsLoader />}

        {filteredPosts.length == 0 && !hasMorePosts && (
          <div
            style={{
              marginBottom: "-1px",
              marginTop: "40px",
              textAlign: "center",
              top: "4px",
              minHeight: "50px",
            }}
          >
            {Loc.currentLang.post.noFeeds}
          </div>
        )}
      </div>

      {/* Modal to create a post */}
      {showModal && (
        <CreatePostpopup
          visibilityPermission={IsVisible}
          setShowCreatePost={setShowModal}
          Postdata={userInfo?.type == "Channel" ? userInfo : props?.Postdata}
          setFeedChunks={setFeedChunks}
          feedChunks={feedChunks}
          handleAddComment={undefined}
          handlePostComment={undefined}
          showAddComment={false}
          setShowAddComment={undefined}
          setCommentMedia={undefined}
          isHuddlePostTab={props?.isHuddlePostTab}
        />
      )}
    </Box>
  );
};

export default React.memo(AVFeeds);
